// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tier-list-container {
  animation: fadeIn 1s;
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.tier-list-container ul {
  padding: 0;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.tier-list-container ul li {
  font-size: 14px;
  font-weight: 400;
  color: #2A2A2A;
  margin: 0;
  line-height: 20px;
}
.tier-list-container ul li > svg {
  white-space: nowrap;
  margin-top: 2px;
  margin-right: 8px;
}
.tier-list-container .tier-info-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.tier-list-container .tier-info-container .tier-details,
.tier-list-container .tier-info-container .broker-details {
  flex: 1 1;
  background-color: #fff;
  border-radius: 24px;
  padding: 20px;
  border: 1px solid #EBEBEB;
}
.tier-list-container .tier-info-container .tier-details {
  padding: 16px 24px;
}
.tier-list-container .tier-info-container .broker-details {
  max-width: 381px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tier-list-container .tier-info-container .tier-icon,
.tier-list-container .tier-info-container .broker-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 10px;
}
.tier-list-container .tier-info-container .broker-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.tier-list-container .tier-info-container .broker-content .broker-avatar-container {
  position: relative;
}
.tier-list-container .tier-info-container .broker-content .broker-avatar-container .broker-avatar {
  margin: 0;
}
.tier-list-container .tier-info-container .broker-content .broker-avatar-container > svg {
  position: absolute;
  right: 0;
  bottom: 0;
}
.tier-list-container .tier-info-container .tier-content {
  display: flex;
  column-gap: 32px;
}
.tier-list-container .tier-info-container .tier-content.Q > div:first-child {
  background: linear-gradient(102.37deg, #2a2a2a -11%, #2a2a2a 47.16%, #2c2c2c 100%);
}
.tier-list-container .tier-info-container .tier-content.Q > div:first-child > div h2,
.tier-list-container .tier-info-container .tier-content.Q > div:first-child > div p,
.tier-list-container .tier-info-container .tier-content.Q > div:first-child > div span {
  color: white !important;
}
.tier-list-container .tier-info-container .tier-content.Q > div:first-child > div h3 {
  color: #ffc107 !important;
}
.tier-list-container .tier-info-container .tier-content.Q > div:first-child h4 {
  background-color: #FFECAD !important;
  color: #FAC91F !important;
}
.tier-list-container .tier-info-container .tier-content > div {
  flex: 1 1;
  height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.tier-list-container .tier-info-container .tier-content > div:first-child {
  background-color: #F9F9F9;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.tier-list-container .tier-upgrades {
  display: flex;
  flex-direction: column;
}
.tier-list-container .tier-upgrades .tier-cards {
  display: flex;
  column-gap: 32px;
  justify-content: space-between;
}
.tier-list-container .tier-upgrades .tier-cards .tier-card {
  display: flex;
  border-radius: 16px;
  background-color: #F9F9F9;
  min-height: 284px;
  max-width: 624px;
  width: 100%;
}
.tier-list-container .tier-upgrades .tier-cards .tier-card.queen .tier-card-content {
  background: linear-gradient(102.37deg, #2a2a2a -11%, #2a2a2a 47.16%, #2c2c2c 100%);
}
.tier-list-container .tier-upgrades .tier-cards .tier-card .tier-card-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 242px;
  background-color: #F3F3F3;
  border-radius: 16px;
}
.tier-list-container .tier-upgrades .tier-cards .tier-card .tier-card-content > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.tier-list-container .tier-upgrades .tier-cards .tier-card .tier-perks {
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.tier-list-container p.tier-perks-description {
  margin: 0;
  font-size: 14px;
  max-width: 232px;
  width: 100%;
  background-color: #F3F3F3;
  font-weight: 700;
  padding: 8px;
  border-radius: 8px;
  text-align: center;
  align-self: center;
}
.tier-list-container p.tier-perks-description.house {
  background-color: #EBEBEB;
}
.tier-list-container p.tier-perks-description.queen {
  background-color: #FFECAD;
  color: #E7B713 !important;
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .tier-list-container .tier-info-container {
    flex-direction: column !important;
  }
  .tier-list-container .tier-info-container .broker-details {
    max-width: 425px;
  }
  .tier-list-container .tier-upgrades .tier-cards {
    flex-direction: column !important;
    row-gap: 32px;
  }
  .tier-list-container .tier-upgrades .tier-cards .tier-card {
    max-width: none;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .tier-list-container .tier-info-container {
    flex-direction: column !important;
  }
  .tier-list-container .tier-info-container .broker-details {
    max-width: 425px;
  }
  .tier-list-container .tier-upgrades .tier-cards {
    flex-direction: column !important;
    row-gap: 32px;
  }
  .tier-list-container .tier-upgrades .tier-cards .tier-card {
    max-width: none;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .tier-list-container .tier-info-container {
    flex-direction: column !important;
  }
  .tier-list-container .tier-info-container .broker-details {
    max-width: 425px;
  }
  .tier-list-container .tier-info-container .tier-details .tier-content {
    flex-direction: column !important;
    row-gap: 24px;
  }
  .tier-list-container .tier-upgrades .tier-cards {
    flex-direction: column !important;
    row-gap: 32px;
  }
  .tier-list-container .tier-upgrades .tier-cards .tier-card {
    max-width: none;
    flex-direction: column !important;
  }
  .tier-list-container .tier-upgrades .tier-cards .tier-card .tier-card-content {
    max-width: none;
  }
  .tier-list-container .tier-upgrades .tier-cards .tier-card .tier-perks {
    row-gap: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/BeeTier/modules/TierList/tierList.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,oBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAGI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AADR;AAGQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AADZ;AAGY;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;AADhB;AAMI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAJR;AAMQ;;EAEI,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAJZ;AAQQ;EACI,kBAAA;AANZ;AASQ;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAPZ;AAUQ;;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AARZ;AAWQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AATZ;AAWY;EACI,kBAAA;AAThB;AAWgB;EACI,SAAA;AATpB;AAYgB;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AAVpB;AAeQ;EACI,aAAA;EACA,gBAAA;AAbZ;AAiBoB;EACI,kFAAA;AAfxB;AAkB4B;;;EAGI,uBAAA;AAhBhC;AAkB4B;EACI,yBAAA;AAhBhC;AAoBwB;EACI,oCAAA;EACA,yBAAA;AAlB5B;AAwBY;EACI,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAtBhB;AAwBgB;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAtBpB;AA4BI;EACI,aAAA;EACA,sBAAA;AA1BR;AA4BQ;EACI,aAAA;EACA,gBAAA;EACA,8BAAA;AA1BZ;AA4BY;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AA1BhB;AA6BoB;EACI,kFAAA;AA3BxB;AAgCgB;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AA9BpB;AAgCoB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AA9BxB;AAkCgB;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAhCpB;AAsCI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AApCR;AAqCQ;EACI,yBAAA;AAnCZ;AAqCQ;EACI,yBAAA;EACA,yBAAA;AAnCZ;;AC7JY;EDwMJ;IACI,iCAAA;EAvCV;EAwCU;IACI,gBAAA;EAtCd;EA0CU;IACI,iCAAA;IACA,aAAA;EAxCd;EAyCc;IACI,eAAA;EAvClB;AACF;ACpLY;ED+MJ;IACI,iCAAA;EAxBV;EAyBU;IACI,gBAAA;EAvBd;EA2BU;IACI,iCAAA;IACA,aAAA;EAzBd;EA0Bc;IACI,eAAA;EAxBlB;AACF;ACnMY;EDmOJ;IACI,iCAAA;EA7BV;EA8BU;IACI,gBAAA;EA5Bd;EA+Bc;IACI,iCAAA;IACA,aAAA;EA7BlB;EAkCU;IACI,iCAAA;IACA,aAAA;EAhCd;EAiCc;IACI,eAAA;IACA,iCAAA;EA/BlB;EAgCkB;IACI,eAAA;EA9BtB;EAgCkB;IACI,aAAA;EA9BtB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.tier-list-container {\r\n    animation: fadeIn 1s;\r\n    padding: 32px 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 32px;\r\n\r\n    ul {\r\n        padding: 0;\r\n        display: flex;\r\n        flex-direction: column;\r\n        row-gap: 8px;\r\n\r\n        li {\r\n            font-size: 14px;\r\n            font-weight: 400;\r\n            color: #2A2A2A;\r\n            margin: 0;\r\n            line-height: 20px;\r\n\r\n            >svg {\r\n                white-space: nowrap;\r\n                margin-top: 2px;\r\n                margin-right: 8px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .tier-info-container {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        gap: 20px;\r\n\r\n        .tier-details,\r\n        .broker-details {\r\n            flex: 1;\r\n            background-color: #fff;\r\n            border-radius: 24px;\r\n            padding: 20px;\r\n            border: 1px solid #EBEBEB;\r\n            //   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n        }\r\n\r\n        .tier-details {\r\n            padding: 16px 24px;\r\n        }\r\n\r\n        .broker-details {\r\n            max-width: 381px;\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: center;\r\n        }\r\n\r\n        .tier-icon,\r\n        .broker-avatar {\r\n            width: 80px;\r\n            height: 80px;\r\n            border-radius: 50%;\r\n            margin-bottom: 10px;\r\n        }\r\n\r\n        .broker-content {\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            height: 100%;\r\n\r\n            .broker-avatar-container {\r\n                position: relative;\r\n\r\n                .broker-avatar {\r\n                    margin: 0;\r\n                }\r\n\r\n                >svg {\r\n                    position: absolute;\r\n                    right: 0;\r\n                    bottom: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        .tier-content {\r\n            display: flex;\r\n            column-gap: 32px;\r\n\r\n            &.Q {\r\n                >div {\r\n                    &:first-child {\r\n                        background: linear-gradient(102.37deg, #2a2a2a -11%, #2a2a2a 47.16%, #2c2c2c 100%);\r\n\r\n                        >div {\r\n                            h2,\r\n                            p,\r\n                            span {\r\n                                color: white !important;\r\n                            }\r\n                            h3 {\r\n                                color: #ffc107 !important;\r\n                            }\r\n                        }\r\n\r\n                        h4 {\r\n                            background-color: #FFECAD !important;\r\n                            color: #FAC91F !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            >div {\r\n                flex: 1;\r\n                height: 320px;\r\n                display: flex;\r\n                flex-direction: column;\r\n                justify-content: space-between;\r\n\r\n                &:first-child {\r\n                    background-color: #F9F9F9;\r\n                    border-radius: 16px;\r\n                    padding: 32px;\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    align-items: center;\r\n                    text-align: center;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .tier-upgrades {\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        .tier-cards {\r\n            display: flex;\r\n            column-gap: 32px;\r\n            justify-content: space-between;\r\n\r\n            .tier-card {\r\n                display: flex;\r\n                border-radius: 16px;\r\n                background-color: #F9F9F9;\r\n                min-height: 284px;\r\n                max-width: 624px;\r\n                width: 100%;\r\n\r\n                &.queen {\r\n                    .tier-card-content{\r\n                        background: linear-gradient(102.37deg, #2a2a2a -11%, #2a2a2a 47.16%, #2c2c2c 100%);\r\n                    }\r\n\r\n                }\r\n\r\n                .tier-card-content {\r\n                    padding: 24px;\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    align-items: center;\r\n                    text-align: center;\r\n                    max-width: 242px;\r\n                    background-color: #F3F3F3;\r\n                    border-radius: 16px;\r\n\r\n                    >div {\r\n                        display: flex;\r\n                        flex-direction: column;\r\n                        align-items: center;\r\n                        text-align: center;\r\n                    }\r\n                }\r\n\r\n                .tier-perks {\r\n                    padding: 24px;\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    justify-content: space-between;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    p.tier-perks-description {\r\n        margin: 0;\r\n        font-size: 14px;\r\n        max-width: 232px;\r\n        width: 100%;\r\n        background-color: #F3F3F3;\r\n        font-weight: 700;\r\n        padding: 8px;\r\n        border-radius: 8px;\r\n        text-align: center;\r\n        align-self: center;\r\n        &.house {\r\n            background-color: #EBEBEB;\r\n        }\r\n        &.queen {\r\n            background-color: #FFECAD;\r\n            color: #E7B713 !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@include media(tablet, mobile) {\r\n    .tier-list-container {\r\n        .tier-info-container {\r\n            flex-direction: column !important; \r\n            .broker-details {\r\n                max-width: 425px;\r\n            }\r\n        }\r\n        .tier-upgrades {\r\n            .tier-cards {\r\n                flex-direction: column !important;\r\n                row-gap: 32px;\r\n                .tier-card {\r\n                    max-width: none;\r\n                }\r\n            }\r\n        }\r\n    }    \r\n}\r\n\r\n@include media(mobile) {\r\n    .tier-list-container {\r\n        .tier-info-container {\r\n            flex-direction: column !important; \r\n            .broker-details {\r\n                max-width: 425px;\r\n            }\r\n            .tier-details {\r\n                .tier-content {\r\n                    flex-direction: column !important;\r\n                    row-gap: 24px;\r\n                }\r\n            }\r\n        }\r\n        .tier-upgrades {\r\n            .tier-cards {\r\n                flex-direction: column !important;\r\n                row-gap: 32px;\r\n                .tier-card {\r\n                    max-width: none;\r\n                    flex-direction: column !important;\r\n                    .tier-card-content {\r\n                        max-width: none;\r\n                    }\r\n                    .tier-perks {\r\n                        row-gap: 40px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }    \r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
